import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 37 36"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "36",
      height: "36",
      x: ".5",
      fill: "#f8f8f8",
      rx: "12"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#60bd3f",
      d: "M23.87 17.569c0 .391.061.77.183 1.138.121.367.303.716.546 1.047a4.145 4.145 0 0 0 1.901 1.45 8.23 8.23 0 0 1-.566 1.323c-.23.429-.492.839-.79 1.23a12.61 12.61 0 0 1-1.304 1.516c-.465.459-1.035.689-1.709.689-.647.024-1.163-.086-1.547-.331-.384-.245-.947-.367-1.689-.367-.755 0-1.328.116-1.72.349-.39.232-.896.36-1.516.385-.647.025-1.22-.21-1.72-.707a14.968 14.968 0 0 1-1.375-1.57 11.461 11.461 0 0 1-1.153-1.965c-.35-.76-.603-1.549-.758-2.37a8.625 8.625 0 0 1-.111-2.46c.08-.833.344-1.592.788-2.278.203-.33.445-.633.729-.909.283-.275.6-.51.95-.707a5.508 5.508 0 0 1 1.143-.459c.398-.11.806-.171 1.224-.184a4.017 4.017 0 0 1 1.81.386c.573.27 1.055.404 1.446.404s.927-.156 1.608-.468a4.123 4.123 0 0 1 2.154-.358c.35.012.698.06 1.042.147.344.085.677.202 1 .348.311.16.598.346.86.56.264.215.496.457.698.726a4.195 4.195 0 0 0-.87.652 4.688 4.688 0 0 0-.667.817 4.094 4.094 0 0 0-.435.955c-.1.33-.151.668-.151 1.01Zm-2.467-6.686a3.64 3.64 0 0 1-.597.533c-.222.16-.455.294-.697.404-.257.11-.523.193-.8.248a4.283 4.283 0 0 1-.839.083 3.71 3.71 0 0 1 .223-1.488c.175-.478.445-.912.809-1.304A4.698 4.698 0 0 1 22.414 8a3.697 3.697 0 0 1-.202 1.524 3.967 3.967 0 0 1-.809 1.36Z"
    }, null, -1)
  ])))
}
export default { render: render }